import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { Logo } from "../Logo";
import { openCookiePreferences } from "../../lib/consent";

export default function LandingFooter() {
  return (
    <>
      <section className="px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl rounded-3xl bg-primary/10 px-6 py-14 text-center sm:px-14 glossy-card" data-testid="landing-footer-cta">
          <h2 className="font-heading text-2xl font-bold tracking-tight sm:text-3xl">Ready to score your next batch of resumes?</h2>
          <p className="mx-auto mt-3 max-w-md text-sm text-muted-foreground sm:text-base">Start free with 10 credits — no credit card required.</p>
          <Button asChild size="lg" className="mt-6" data-testid="landing-footer-cta-btn">
            <Link to="/signup">
              Start Free Trial <ArrowRight className="h-4 w-4" />
            </Link>
          </Button>
        </div>
      </section>

      <footer className="border-t border-border/70 px-4 py-12 sm:px-6 lg:px-8">
        <div className="mx-auto grid max-w-6xl gap-8 sm:grid-cols-4">
          <div>
            <Logo className="h-7" />
            <p className="mt-3 text-sm text-muted-foreground">Resume screening & batch candidate ranking for hiring teams.</p>
          </div>
          <FooterCol title="Product" links={[["Features", "/#features"], ["How it Works", "/#how-it-works"], ["Pricing", "/#pricing"], ["FAQ", "/#faq"]]} />
          <FooterCol title="Company" links={[["About Us", "/about"], ["Contact Us", "/contact"], ["Sign In", "/login"], ["Start Free Trial", "/signup"]]} />
          <div>
            <div className="text-xs font-bold uppercase tracking-wide text-muted-foreground">Legal</div>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors duration-150" data-testid="footer-link-privacy-policy">
                  Privacy &amp; Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-foreground transition-colors duration-150" data-testid="footer-link-terms-&-conditions">
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <button
                  onClick={openCookiePreferences}
                  className="text-muted-foreground hover:text-foreground transition-colors duration-150"
                  data-testid="footer-cookie-preferences-btn"
                >
                  Cookie Preferences
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="mx-auto mt-10 max-w-6xl border-t border-border/60 pt-6 text-xs text-muted-foreground">
          © {new Date().getFullYear()} hireqix. All rights reserved. · support@hireqix.com
        </div>
      </footer>
    </>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="text-xs font-bold uppercase tracking-wide text-muted-foreground">{title}</div>
      <ul className="mt-3 space-y-2 text-sm">
        {links.map(([label, href]) => (
          <li key={label}>
            <Link to={href} className="text-muted-foreground hover:text-foreground transition-colors duration-150" data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}>
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
